import {axiosBlobRequest} from "./apiBase";
import {HtmlToFormatDetails} from "../common/models/file/htmlToFormatDetails.model";
import {BlobResponse} from "../common/interfaces/blobResponse";

export const fileGenerateFromHtml = async (data: HtmlToFormatDetails): Promise<BlobResponse> => {
    return axiosBlobRequest(
        "POST",
        "file/html/generate",
        data,
        { responseType: "blob"}
    );
}